import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'serviceos-ng-local-loader',
  templateUrl: './local-loader.component.html',
  styleUrls: ['./local-loader.component.scss']
})
export class LocalLoaderComponent implements OnInit {

  @Input()
  showLoader = true;

  constructor() { }

  ngOnInit(): void {
  }

}
